export const FETCH_BANK_INFO = 'FETCH_BANK_INFO';
export const FETCH_BANK_INFO_SUCCESS = 'FETCH_BANK_INFO_SUCCESS';
export const FETCH_BANK_INFO_FIELD_SUCCESS = 'FETCH_BANK_INFO_FIELD_SUCCESS';
export const PATCH_BANK_INFO = 'PATCH_BANK_INFO';
export const PATCH_BANK_INFO_SUCCESS = 'PATCH_BANK_INFO_SUCCESS';
export const OPEN_EDIT_PANEL = 'OPEN_EDIT_PANEL';
export const CLOSE_EDIT_PANEL = 'CLOSE_EDIT_PANEL';
export const FETCH_BANK_LIST = 'FETCH_BANK_LIST';
export const FETCH_BANK_LIST_SUCCESS = 'FETCH_BANK_LIST_SUCCESS';

export const fetchBankInfo = () => ({
  type: FETCH_BANK_INFO,
});

export const fetchBankInfoSuccess = ({
  isBankAccountCompleted: bankAccountCompleted,
  ...bankInfoData
}) => ({
  type: FETCH_BANK_INFO_SUCCESS,
  payload: {
    bankAccountCompleted,
    bankInfoData,
  },
});

export const fetchBankInfoFieldSuccess = ({ bankNeedColumn }) => ({
  type: FETCH_BANK_INFO_FIELD_SUCCESS,
  payload: {
    bankNeedColumn,
  },
});
export const patchBankInfo = bankInfoData => ({
  type: PATCH_BANK_INFO,
  payload: {
    bankInfoData,
  },
});

export const patchBankInfoSuccess = ({
  isBankAccountCompleted: bankAccountCompleted,
  ...bankInfoData
}) => ({
  type: PATCH_BANK_INFO_SUCCESS,
  payload: {
    bankAccountCompleted,
    bankInfoData,
  },
});

export const fetchBankList = () => ({
  type: FETCH_BANK_LIST,
});

export const fetchBankListSuccess = bankList => ({
  type: FETCH_BANK_LIST_SUCCESS,
  payload: {
    bankList,
  },
});

export const openEditPanel = (
  { openFromStageLink } = { openFromStageLink: false }
) => ({
  type: OPEN_EDIT_PANEL,
  payload: {
    openFromStageLink,
  },
});

export const closeEditPanel = () => ({
  type: CLOSE_EDIT_PANEL,
});
const INIT_STATE = {
  bankAccountCompleted: false,
  bankEditOpenStatus: false,
  bankInfoFields: [],
  bankInfoData: {},
  bankList: [],
  openFromStageLink: false,
};
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_BANK_INFO_SUCCESS:
      return {
        ...state,
        bankAccountCompleted: action.payload.bankAccountCompleted,
        bankInfoData: action.payload.bankInfoData,
      };
    case FETCH_BANK_INFO_FIELD_SUCCESS:
      return {
        ...state,
        bankInfoFields: [...action.payload.bankNeedColumn],
      };
    case FETCH_BANK_LIST_SUCCESS:
      return {
        ...state,
        bankList: action.payload.bankList,
      };
    case PATCH_BANK_INFO_SUCCESS:
      return {
        ...state,
        bankInfoData: action.payload.bankInfoData,
        bankAccountCompleted: action.payload.bankAccountCompleted,
        bankEditOpenStatus: false,
      };
    case OPEN_EDIT_PANEL:
      return {
        ...state,
        bankEditOpenStatus: true,
        openFromStageLink: action.payload.openFromStageLink,
      };
    case CLOSE_EDIT_PANEL:
      return {
        ...state,
        bankEditOpenStatus: false,
        openFromStageLink: false,
      };
    default:
      return { ...state };
  }
};
export const getBankAccountCompleted = state => state.bank.bankAccountCompleted;
export const getBankInfoFields = state => state.bank.bankInfoFields;
export const getBankInfoData = state => state.bank.bankInfoData;
export const getBankList = state => state.bank.bankList;
export const getBankEditOpenStatus = state => state.bank.bankEditOpenStatus;
export const getOpenFromStageLink = state => state.bank.openFromStageLink;

export default reducer;



// WEBPACK FOOTER //
// ./app/redux/bank.js